// Bảng mã giao diện admin (theo ds-cab tokens.json + BRIEF thiết kế mới).
// Chỉ dùng các mã ở đây; CSS (admin.css) khai cùng giá trị thành biến --adm-* để chạy được dark mode.

export const ADMIN_COLORS = {
  primary: '#2271B1', // brand-600: nút chính, liên kết, tab đang chọn
  primaryHover: '#215C91', // brand-700
  onPrimary: '#FFFFFF',
  soft: '#EFF7FD', // brand-50: nút phụ, mục đang chọn
  onSoft: '#215C91',
  softHover: '#DCEEFA', // brand-100
  focus: '#4FA6DF', // brand-400
  fill: '#F1F4F8', // neutral-50: nút xám nhẹ, chip, ô tìm kiếm, panel lồng
  fillHover: '#E6EBF1',
  onFill: '#364354', // neutral-700
  surface: '#FFFFFF',
  bg: '#F7F9FC', // neutral-25: nền trang, đầu bảng
  heading: '#121C2A', // neutral-900
  text: '#233040', // neutral-800
  nav: '#4A586A', // neutral-600: chữ mục menu chưa chọn
  muted: '#627184', // neutral-500
  subtle: '#8795A6', // neutral-400: placeholder, viền ô nhập
  line: '#E6EBF1', // neutral-100: đường kẻ trong thẻ
  lineStrong: '#D3DBE4', // neutral-200: viền nút viền
  lineInput: '#8795A6',
  success: '#11683F',
  successSoft: '#EAF7F0',
  successFill: '#17834F',
  danger: '#C02A2A',
  dangerSoft: '#FDEEEE',
  dangerHover: '#9B2020',
  warning: '#9A630C',
  warningSoft: '#FFF8E6',
  caFill: '#F6B92B',
} as const;

// Giá trị ở chế độ tối (token vai trò dark trong tokens.json).
export const ADMIN_COLORS_DARK = {
  bg: '#0A121D', // neutral-950
  surface: '#121C2A', // neutral-900
  surface2: '#233040', // neutral-800
  heading: '#FFFFFF',
  text: '#E6EBF1',
  muted: '#8795A6',
  line: '#233040',
  lineStrong: '#364354',
  lineInput: '#4A586A',
  onSoft: '#8AC4EB', // brand-300
} as const;

export const ADMIN_RADIUS = { sm: 6, md: 12, lg: 16, xl: 24, full: 9999 } as const;

export const ADMIN_SHADOW = {
  card: '0 1px 2px rgba(18,28,42,0.04), 0 4px 16px rgba(18,28,42,0.06)',
  menu: '0 12px 32px rgba(18,28,42,0.14), 0 2px 6px rgba(18,28,42,0.06)',
  primary: '0 4px 12px rgba(34,113,177,0.30)',
} as const;

export const ADMIN_FONT = "'Inter', system-ui, sans-serif";

// Bề rộng menu trái và chiều cao thanh trên theo màn AdminSidebar / AdminHeader.
export const ADMIN_LAYOUT = { sidebarWidth: 288, headerHeight: 80, mainPadding: 32, sectionGap: 32 } as const;

export type AdminTone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';
